<div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
  <!-- Site Web -->
  <mat-form-field appearance="outline" class="w-full" subscriptSizing="dynamic">
    <mat-label>Site web professionnel</mat-label>
    <input
      matInput
      type="url"
      aria-label="Site web professionnel"
      placeholder="mon-agence-immobiliere.fr"
      [value]="internalLinks().website || ''"
      (input)="onChange('website', $any($event.target).value)"
    />
    <mat-icon matPrefix class="mr-2.5 text-neutral-8">language</mat-icon>
  </mat-form-field>

  <!-- Avis Google -->
  <mat-form-field appearance="outline" class="w-full" subscriptSizing="dynamic">
    <mat-label>Lien avis Google (Google Business)</mat-label>
    <input
      matInput
      type="url"
      aria-label="Lien avis Google"
      placeholder="g.page/r/..."
      [value]="internalLinks().googleReviewUrl || ''"
      (input)="onChange('googleReviewUrl', $any($event.target).value)"
    />
    <mat-icon matPrefix class="mr-2.5 text-amber-9">star</mat-icon>
  </mat-form-field>

  <!-- Immodvisor -->
  <mat-form-field appearance="outline" class="w-full" subscriptSizing="dynamic">
    <mat-label>Lien Immodvisor</mat-label>
    <input
      matInput
      type="url"
      aria-label="Lien Immodvisor"
      placeholder="www.immodvisor.com/professionnels/..."
      [value]="internalLinks().opinionSystemUrl || ''"
      (input)="onChange('opinionSystemUrl', $any($event.target).value)"
    />
    <mat-icon matPrefix class="mr-2.5 text-blue-9">verified</mat-icon>
  </mat-form-field>

  <!-- LinkedIn -->
  <mat-form-field appearance="outline" class="w-full" subscriptSizing="dynamic">
    <mat-label>Profil LinkedIn</mat-label>
    <input
      matInput
      type="url"
      aria-label="Profil LinkedIn"
      placeholder="www.linkedin.com/in/..."
      [value]="internalLinks().linkedin || ''"
      (input)="onChange('linkedin', $any($event.target).value)"
    />
    <mat-icon matPrefix class="mr-2.5 text-sky-9">work</mat-icon>
  </mat-form-field>
</div>
